<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div v-if="keyVault.sharedType" class="dialog-title" v-t="'message.action_add_shared_key'"></div>
                <div v-else class="dialog-title" v-t="'message.action_add_private_key'"></div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form label-width="150px" >
                        <div class="dialog-form-item">
                            <el-form-item prep="displayName" ref="displayName">
                                <div slot="label" style="text-align:left"><span v-t="'message.item_display_name'"></span> <span class="required" v-t="'message.item_required'"></span></div>
                                <el-input id="displayName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.displayName.value"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="InputCheckAll()"/>
                            </el-form-item>
                        </div>
                        <div class="dialog-form-item">
                            <el-form-item prep="type" ref="type">
                                <div slot="label" style="text-align:left"><span v-t="'message.item_target_os'"></span> <span class="required" v-t="'message.item_required'"></span></div>
                                <el-select v-model="inputForm.type.value" style="margin-left=15px" @change="handleChangeType()">
                                    <el-option v-for="type in typeList" :key="type.value" :label="type.name" :value="type.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="dialog-form-item">
                            <el-form-item prep="token" ref="token">
                                <div slot="label" style="text-align:left"><span v-t="'message.item_token'"></span> <span class="required" v-t="'message.item_required'"></span></div>
                                <el-input id="token" size="large" type="textarea" :autosize="{ minRows: 7, maxRows: 7}" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.token.value"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="InputCheckAll()"/>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.$data.disableButton" @click="addKey()" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import charactercheck from './charactercheck.js';
import commonUtil from './commonutil.js';
import commonValidate from './common-validate.js';
import constants from './constants.js';

export default {
    data() {
        return {
            inputForm: {
                displayName: { validationRule: "reqDisplayName",       valid: false,    value: null,   isComposing: false },
                type:        { validationRule: "selectItem",           valid: false,    value: null,   isComposing: false },
                token:       { validationRule: "reqToken",             valid: false,    value: null,   isComposing: false },
            },
            typeList : [
                { name: "Android", value: constants.VAULT_TARGET_TYPE_ANDROID },
                { name: "iOS",     value: constants.VAULT_TARGET_TYPE_IOS },
            ],
            disableButton: true,
            existTargetType: [],
        };
    },
    methods: {
        handleChangeType() {
            if (this.existTargetType.includes(this.inputForm.type.value)) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_same_type_key"));
                this.inputForm.type.value = null;
            }
            this.inputCheck("type");
        },
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            let validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value);
            if (validateResult.valid) {
                this.$refs[eventTargetId].clearValidate();
                this.inputForm[eventTargetId].valid = true;
            } else {
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
                this.inputForm[eventTargetId].valid = false;
            }
            this.setButtonStatus();
        },
        InputCheckAll() {
            for (let targetId in this.inputForm) {
                this.inputCheck(targetId);
            }
        },
        setButtonStatus() {
            if (commonValidate.checkFormValidation(this.inputForm)) {
                this.disableButton = false;
            } else {
                this.disableButton = true;
            }
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
        addKey() {
            this.$emit('save', {
                displayName: this.inputForm.displayName.value,
                serviceId: this.keyVault.serviceId,
                providerName: this.keyVault.providerName,
                targetType: this.inputForm.type.value,
                token: this.inputForm.token.value,
                sharedType: this.keyVault.sharedType,
                tokenType: constants.VAULT_TOKEN_TYPE_ACCESS
            })
        },
    },
    created: function() {
        if (this.keyVault.sharedType) {
            for (let keyVault of this.commonKeyVaultList) {
                this.existTargetType.push(keyVault.targetType);
            }
        } else {
            for (let keyVault of this.privateKeyVaultList) {
                if (keyVault.ownerUserId == this.appData.loginUserObjectId) {
                    this.existTargetType.push(keyVault.targetType);
                }
            }
        }
    },
    props: [ 'appData', 'keyVault', 'commonKeyVaultList', 'privateKeyVaultList' ]
}
</script scoped>
<style scoped>
</style>

